import { ConfigurationConstants } from './config';

export const Redirects = {
  [ConfigurationConstants.START_UP_MENU]: '/start-up-menu',
  [ConfigurationConstants.CREATE_DOCUMENTATION_WORKSPACE_CHOICE]: '/home',
  [ConfigurationConstants.COMPLIANCE_CENTRAL_WORKSPACE_CHOICE]: '/central/compliance'
};
  